// app/frontend/components/inbox/TypingIndicator.tsx

interface TypingIndicatorProps {
  senderName: string
}

export function TypingIndicator({ senderName }: TypingIndicatorProps) {
  return (
    <div className="flex items-center gap-2 px-4 py-2 text-sm text-muted-foreground">
      <div className="flex gap-1">
        <span className="w-2 h-2 bg-muted-foreground/50 rounded-full animate-bounce [animation-delay:-0.3s]" />
        <span className="w-2 h-2 bg-muted-foreground/50 rounded-full animate-bounce [animation-delay:-0.15s]" />
        <span className="w-2 h-2 bg-muted-foreground/50 rounded-full animate-bounce" />
      </div>
      <span>{senderName} is typing...</span>
    </div>
  )
}

export default TypingIndicator
